import { IonButton, IonIcon, IonRow } from "@ionic/react";
import "./InspectionFooter.css";
import {
  addCircleOutline,
  arrowForwardOutline,
  checkmarkCircle,
} from "ionicons/icons";
import ListItemDamage from "./ListItemDamage";
import { useHistory } from "react-router";

interface InspectionFooterProps {
  nextUrl: string;
  setDamageModalIsOpen: (value: boolean) => void;
  setSecurityModalIsOpen: (value: boolean) => void;
  setReportDamageModal: (value: boolean) => void;
  damageList: {
    id: string;
    number: number;
    type: string;
    label: string;
    damageId?: string;
  }[];
  setSelectedDamage: (value: string) => void;
  side: string;
  securityCheck?: boolean;
}

const InspectionFooter: React.FC<InspectionFooterProps> = ({
  nextUrl,
  setDamageModalIsOpen,
  setReportDamageModal,
  damageList,
  setSelectedDamage,
  side,
  securityCheck,
  setSecurityModalIsOpen,
}) => {
  const history = useHistory();
  return (
    <div className="InspectionFooter">
      <IonRow>
        {side === "Document" ? "Défauts" : "Dégats"} déjà présents
      </IonRow>
      {damageList.length > 0 ? (
        <div className="InspectionFooter-list">
          {damageList.map((el) => (
            <ListItemDamage
              itemNumber={el.number}
              label={el.label}
              value={el.type}
              color={el.damageId ? "error" : "warning"}
              onClick={() => {
                setDamageModalIsOpen(true);
                setSelectedDamage(
                  el.damageId || `${el.number}-${el.damageId}` || ""
                );
              }}
            />
          ))}
        </div>
      ) : (
        <div className="InspectionFooter-nodamage">
          <IonIcon
            icon={checkmarkCircle}
            slot="start"
            className="InspectionFooter-nodamage-icon"
          />{" "}
          <span>Pas de {side === "Document" ? "défaut" : "dommage"}</span>
        </div>
      )}
      <div className="InspectionFooter-buttons">
        <IonButton
          color="danger"
          onClick={() => setReportDamageModal(true)}
          className="InspectionFooter-button"
        >
          <IonIcon icon={addCircleOutline} slot="start" />
          {side === "Document" ? "Signaler un défaut" : "Nouveau dommage"}
        </IonButton>
        <IonButton
          color="success"
          routerDirection="forward"
          className="InspectionFooter-button"
          onClick={() => {
            if (securityCheck) {
              setSecurityModalIsOpen(true);
            } else {
              history.push(nextUrl);
            }
          }}
        >
          Tout est OK <IonIcon icon={arrowForwardOutline} slot="end" />
        </IonButton>
      </div>
    </div>
  );
};

export default InspectionFooter;
